import React, { useState , useEffect} from "react";
import { Icon } from "semantic-ui-react";
import "../../App.css";
import AVAChatbox from "./AVAChatbox";

function AVAChatbot() {
  // State to track visibility
  const [showChatbox, setShowChatbox] = useState(false);
  const [iframeLoad, setIFrameLoad] = useState(false);

  useEffect(() => {
    
       if (window.top !== window.self){
          
          setIFrameLoad(true);
        }
        else{
          console.log('Self loaded');
        }
  }, []);

  // Function to toggle visibility
  const toggleVisibility = () => {

  const allowedOrigins = [
    process.env.REACT_APP_API_URL_SELF_SERVICE_ORIGIN,
    process.env.REACT_APP_API_URL_AVBOB_WEBSITE_ORIGIN];
    
    setShowChatbox(!showChatbox);
    if(iframeLoad){
      if (!showChatbox){
        allowedOrigins.forEach(origin => {
        window.parent.postMessage(
          { content: 'AVAOpen' },
          origin
        );
        });
      }
      else{
        allowedOrigins.forEach(origin => {
        window.parent.postMessage(
          { content: 'AVAClosed' },
          origin
        );
        });
      }
    }
   
  };

  return (
    <div className="chatContainer">
      {!showChatbox && (
        <div className="chatCircle" onClick={toggleVisibility}>
          <Icon size="big" name="chat outline" />
        </div>
      )}
      {/* {showChatbox && ( */}
        <AVAChatbox closeChatbox={toggleVisibility} isOpen={showChatbox} />
      {/* )} */}
    </div>
  );
}

export default AVAChatbot;
